<template>
  <div style="height: 100%;">
    <div class="goback-large c-pointer" style="font-size:20px;" @click="onBackToHomeButton">
      <i class="fal fa-arrow-left"></i> {{componentMode === 'add' ? '제어 스크립트 추가' : '제어 스크립트 수정'}}
    </div>
    <el-form style="height:calc(100% - 35px);" :model="formData" ref="formData" :rules="rules">
      <el-row type="flex" :gutter="20" class="mr-b25">
        <el-col :span="12">
          <el-form-item label="스크립트 ID" prop="scriptId">
            <el-input placeholder="스크립트 ID를 입력해주세요" :disabled="componentMode === 'update'" v-model="formData.scriptId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="스크립트 명" prop="scriptName">
            <el-input placeholder="스크립트 명을 입력해주세요" v-model="formData.scriptName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="title-bar vertical-center-box" type="flex" justify="start">
        <div class="title-h4">스크립트</div>
        <w-forbidden-command-keyword-legend class="mr-l4" ref="forbiddenCommandKeywordLegend" />
        <el-select class="mr-l15" v-if="componentMode === 'add' && managetypeId === 'NMS'"  @change="onChangeSelectData" v-model="formData.objCompanyId">
          <el-option v-for="item in vendorList" :key="item.objCompanyId" :value="item.objCompanyId" :label="item.objCompanyName"></el-option>
        </el-select>
      </el-row>
      <el-row style="height:calc(100% - 111px);" type="flex" :gutter="15" v-show="componentMode === 'add'">
        <el-col :span="10">
          <el-table :data="tableData" height="100%" ref="scriptTable" row-class-name="c-pointer" @row-click="onClickVendorScript" highlight-current-row >
            <el-table-column label="템플릿 이름" :prop="managetypeId === 'NMS' ? 'templateName' : 'commandName'"></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="14">
          <el-input class="vertical-fit-textarea" style="height:100%;" v-model="formData.scriptContents" type="textarea" :rows="27"></el-input>
        </el-col>
      </el-row>
      <el-row style="height:calc(100% - 111px);" v-show="componentMode === 'update'">
        <el-input class="vertical-fit-textarea" style="height:100%;" v-model="formData.scriptContents" type="textarea" :rows="27"></el-input>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import NetdeviceCommonAPI from '@/api/common/netdevice';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import serverSettingApi from '@/api/settings/server/server-settings';
import commonAPI from '@/api/performance/common';
import msgUtil from '@/utils/message';
import { cloneDeep } from 'lodash';
import ForbiddenCommandScriptMixin from '@/mixins/forbidden-command-script';

export default {
  name: 'WControlScriptSetComponent',
  mixins: [ForbiddenCommandScriptMixin],
  props: {
    obj: {
      type: Object,
    },
    componentMode: {
      type: String,
    },
  },
  data() {
    return {
      rules: {
        scriptId: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
        scriptName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
      formData: {
        objCompanyId: '',
        scriptId: '',
        scriptName: '',
        scriptContents: '',
      },
      targetTitle: '',
      tableData: [],
      vendorList: [],
    };
  },
  computed: {
    managetypeId() {
      return this.obj !== undefined ? this.obj.objManagetypeId : null;
    },
  },
  mounted() {
    NetdeviceCommonAPI.getProvidedCompanyList().then((res) => {
      if (res.data.success) {
        this.vendorList = res.data.data;
      }
    });
  },
  methods: {
    // 제어 스크립트 추가, 수정 데이터 세팅
    componentSetData(item) {
      // init
      this.$refs.formData.resetFields();
      if (item) {
        this.formData = cloneDeep(item);
        // this.formData.scriptContents = item.data[0].scriptContents;
        delete this.formData.data;
      } else {
        this.formData = {
          objCompanyId: '',
          scriptId: '',
          scriptName: '',
          scriptContents: '',
        };

        if (this.managetypeId === 'NMS') {
          this.onChangeSelectData(this.vendorList[0].objCompanyId);
        } else if (this.managetypeId === 'SMS') {
          serverSettingApi.getAgentCommandList({ objtypeId: this.obj.objtypeId }).then((response) => {
            const result = response.data;
            if (result.success) {
              this.tableData = result.data;
            } else {
              this.tableData = [];
            }
          }).catch(() => {
            this.tableData = [];
          });
        }
        this.formData.objCompanyId = this.vendorList[0].objCompanyId;
      }
    },
    onBackToHomeButton() {
      this.$emit('on-back-to-home-button');
    },
    onChangeSelectData(val) {
      NetdeviceSettingAPI.getTemplateVendorListByCompany({ objCompanyId: val }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.formData.scriptContents = '';
        }
      });
    },
    onClickVendorScript(row) {
      if (this.managetypeId === 'NMS') {
        this.formData.scriptContents = row.script;
      } else {
        this.formData.scriptContents = row.commandContents;
      }
    },
    // 저장 매커니즘
    onSaveButtonClick() {
      this.$refs.formData.validate().then((valiResponse) => {
        if (valiResponse) {
          // 수행금지명령어 확인 로직
          const forbiddenCommandList = this.$refs.forbiddenCommandKeywordLegend.getForbiddenCommandList();
          const scriptContents = this.formData.scriptContents;
          if (this.checkForbiddenCommand(forbiddenCommandList, scriptContents)) {
            return;
          }
          const target = '제어 스크립트';
          const action = msgUtil.action.SAVE;
          // api
          if (this.componentMode === 'add') {
            this.formData.scriptType = this.obj.objManagetypeId === 'NMS' ? 'TELNET' : 'CLI';
            this.formData.managetypeId = this.obj.objManagetypeId;
            commonAPI.insertCtrlScriptSet(this.formData).then((res) => {
              if (res.data.success) {
                this.$emit('load-data');
                this.onBackToHomeButton();
                this.$message(msgUtil.getResultMsgData(action, target, true));
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            commonAPI.updateCtrlScriptSet(this.formData).then((res) => {
              if (res.data.success) {
                this.$emit('load-data');
                this.onBackToHomeButton();
                this.$message(msgUtil.getResultMsgData(action, target, true));
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        }
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ControlScriptSetComponent.vue